import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/views/Dashboard.vue';
import Users from '@/views/system/Users.vue';
import Roles from '@/views/system/Roles.vue';
import Menus from '@/views/system/Menus.vue';
import Configs from '@/views/system/Configs.vue';
import Depts from '@/views/system/Depts.vue';
import Login from '@/views/Login.vue';
import FacebookBinding from '@/views/meta/FacebookBinding.vue';
import Materials from '@/views/material/Materials.vue';
import Tags from '@/views/material/Tags.vue';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/login', name: 'Login', component: Login },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard },
    { path: '/system/users', name: 'Users', component: Users },
    { path: '/system/roles', name: 'Roles', component: Roles },
    { path: '/system/menus', name: 'Menus', component: Menus },
    { path: '/system/configs', name: 'Configs', component: Configs },
    { path: '/system/depts', name: 'Depts', component: Depts },
    { path: '/system/job', name: 'Job', component: () => import('@/views/system/job/index.vue') },
    { path: '/system/job-log', name: 'JobLog', component: () => import('@/views/system/job-log/index.vue') },
    { path: '/meta/facebook/binding', name: 'FacebookBinding', component: FacebookBinding },
    { path: '/material/materials', name: 'Materials', component: Materials },
    { path: '/material/download-tasks', name: 'DownloadTasks', component: () => import('@/views/material/DownloadTasks.vue') },
    { path: '/material/ai-generate-tasks', name: 'AiGenerateTasks', component: () => import('@/views/material/AiGenerateTasks.vue') },
    { path: '/material/ai-generate-templates', name: 'AiGenerateTemplates', component: () => import('@/views/material/AiGenerateTemplates.vue') },
    { path: '/material/tags', name: 'Tags', component: Tags },
    { path: '/material/folder-ownership', name: 'FolderOwnership', component: () => import('@/views/material/FolderOwnership.vue') },
    { path: '/material/scrape', name: 'MaterialScrape', component: () => import('@/views/material/scrape/index.vue') },
    { path: '/material/fb-scrape', name: 'FbScrape', component: () => import('@/views/material/fb-scrape/index.vue') },
    { path: '/report/material-consumption', name: 'MaterialConsumption', component: () => import('@/views/report/MaterialConsumption.vue') },
    { path: '/report/insights', name: 'InsightsReport', component: () => import('@/views/report/InsightsReport.vue') },
    { path: '/report/book-summary', name: 'BookSummary', component: () => import('@/views/report/BookSummary.vue') },
    { path: '/report/user-summary', name: 'UserSummary', component: () => import('@/views/report/UserSummary.vue') },
    { path: '/report/books-with-materials', name: 'BooksWithMaterials', component: () => import('@/views/report/BooksWithMaterials.vue') },
    { path: '/system/fb-debug', name: 'FbDebug', component: () => import('@/views/system/FbDebug.vue') },
    { path: '/dev/tools', name: 'DevTools', component: () => import('@/views/dev/DevTools.vue') },
    { path: '/dev/batch-create-test', name: 'BatchCreateTest', component: () => import('@/views/dev/BatchCreateTest.vue') },
    { path: '/dev/campaign-books', name: 'CampaignBookQuery', component: () => import('@/views/dev/CampaignBookQuery.vue') },
    { path: '/report/strategy-analysis', name: 'StrategyAnalysis', component: () => import('@/views/report/StrategyAnalysis.vue') }
  ]
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.path === '/login') {
    if (token) {
      next('/dashboard');
    } else {
      next();
    }
    return;
  }
  if (!token) {
    next('/login');
    return;
  }
  next();
});

export default router;
